<script setup lang="ts">
import { GpBrandMessage } from '@gportal/uikit';
import type { ServiceError } from 'gpcore-apikit/grpc/types';

defineProps<{
  error: Error | ServiceError;
}>();
</script>

<template>
  <GpBrandMessage class="tw-mx-auto tw-mt-4">
    <p class="tw-font-bold tw-uppercase">
      <slot></slot>
    </p>

    <pre class="tw-mt-2 tw-w-full tw-whitespace-break-spaces tw-text-sm">{{ error.message }}</pre>
  </GpBrandMessage>
</template>

<style scoped></style>
